import { computed, inject } from 'vue';

import { transactionProviderKey as transactionProvider,
  initialValuesTransactionProvider,
} from '@/modules/transaction/constants/transactionProvider.constant';
import {
  REGULATORY_COMPANY_COUNTRIES,
  REGULATORY_MESSAGES,
} from '@/shared/common/constants/regulatory.constant';
import { useAccountStore } from '@/stores/account';

const COP_CURRENCY_CODE = 'COP';
const DEFAULT_SECURE_FOOTER_TEXT = 'Sistema seguro';

/**
 * Resuelve el texto regulatorio del footer en el flujo de transacciones.
 * CO usa isSedpe del provider; CL lee el store directamente.
 */
export function useTransactionSecureFooterText() {
  const accountStore = useAccountStore();

  const { isSedpe, isNational, originRoute, destinationRoute } = inject(
    transactionProvider,
    initialValuesTransactionProvider
  );

  const isColombiaNationalCOP = computed(() => {
    const originCurrencyCode = originRoute.value?.currency?.code ?? '';
    const destinationCurrencyCode = destinationRoute.value?.currency?.code ?? '';

    return (
      isSedpe.value &&
      isNational.value &&
      (originCurrencyCode === COP_CURRENCY_CODE ||
        destinationCurrencyCode === COP_CURRENCY_CODE)
    );
  });

  const isChileNationalCLP = computed(() => {
    const companyCountry = accountStore.getCompanyCountry?.toUpperCase() ?? '';
    return companyCountry === REGULATORY_COMPANY_COUNTRIES.CHILE && isNational.value;
  });

  const shouldShowTransactionRegulatoryNotice = computed(
    () => isColombiaNationalCOP.value || isChileNationalCLP.value
  );

  const secureFooterText = computed(() => {
    if (isChileNationalCLP.value) {
      return REGULATORY_MESSAGES.CHILE_GLOBAL_CARD_SA;
    }

    if (isColombiaNationalCOP.value) {
      return REGULATORY_MESSAGES.COLOMBIA_GLOBAL_81;
    }

    return DEFAULT_SECURE_FOOTER_TEXT;
  });

  return {
    secureFooterText,
    shouldShowTransactionRegulatoryNotice,
  };
}